import React from 'react';
import Applications from './view';
import { useAppContext } from '../../lib/context';

const ApplicationsContainer: React.FC = () => {
  const { user, apps, isOpenVPNEnabled } = useAppContext();

  return (
    <Applications user={user} apps={apps} isOpenVPNEnabled={isOpenVPNEnabled} />
  );
};

export default ApplicationsContainer;
